import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/core";
import update from "immutability-helper";
import { get, map, toLower, toString } from "lodash";

import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Box from "@material-ui/core/Box";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import DatePicker from "../../Common/DatePicker";
import IncrementalInput from "../../Common/IncrementalInput";
import FormSection from "../../Common/FormSection";

import { formatDate } from "../../../utils/date";

import colors from "../../../assets/style/colors";

const styles = {
  bottomLine: {
    borderBottom: `1px solid ${colors.veryLighPink}`,
  },
  radio: {
    color: colors.black54,
    fontSize: "1em !important",
    marginRight: "40px !important",
  },
  radioRoot: {
    padding: "0px",
    marginRight: "10px",
  },
  controlLabel: {
    margin: "2px 0px",
  },
  inputLabel: {
    fontWeight: "400 !important",
    color: colors.black,
  },
};

const VisitRestrictionsSettings = (props) => {
  const { classes, editMode, formValues } = props;

  const handleChange = (key, value) => {
    props.handleChange(
      "visitRestrictions",
      update(formValues, {
        [key]: { $set: value },
      })
    );
  };

  const formatDateLabel = (date) => {
    return `${formatDate(date, "MMM Do, YYYY")}`;
  };

  if (editMode) {
    return (
      <Grid container direction="column">
        <Grid item className={classes.bottomLine}>
          <Checkbox color="primary" checked={true} />
          <span className="text-54">{I18n.get("common_site")}</span>
        </Grid>
        <Grid item container>
          <Grid item style={{ margin: "24px" }}>
            <Box className="bold-500">
              {I18n.get("scheduler_siteVisitsAllowed")}
            </Box>
            <RadioGroup
              name="siteVisitsAllowedType"
              value={get(formValues, ["siteVisitsAllowedType"]) || ""}
              onChange={(e) =>
                handleChange("siteVisitsAllowedType", e.target.value)
              }
            >
              <FormControlLabel
                value={"day"}
                control={
                  <Radio
                    color="primary"
                    classes={{ root: classes.radioRoot }}
                  />
                }
                label={toLower(I18n.get("common_day"))}
                labelPlacement="end"
                classes={{ label: classes.radio, root: classes.controlLabel }}
              />
              <FormControlLabel
                value={"timeSlot"}
                control={
                  <Radio
                    color="primary"
                    classes={{ root: classes.radioRoot }}
                  />
                }
                label={toLower(I18n.get("scheduler_timeSlot"))}
                labelPlacement="end"
                classes={{ label: classes.radio, root: classes.controlLabel }}
              />
            </RadioGroup>
          </Grid>
          <Grid item>
            <IncrementalInput
              name="siteVisitsAllowedNb"
              value={get(formValues, ["siteVisitsAllowedNb"])}
              handleChange={(value) =>
                handleChange("siteVisitsAllowedNb", value)
              }
            />
          </Grid>
        </Grid>
        <Grid item className={classes.bottomLine}>
          <Checkbox color="primary" checked={true} />
          <span className="text-54">{I18n.get("scheduler_hosts")}</span>
        </Grid>
        <Grid item style={{ marginTop: "20px" }}>
          <Grid container alignItems="flex-end">
            <Grid item className="flexCenter">
              <Checkbox color="primary" checked={true} />
              <span>{I18n.get("scheduler_visitorsAllowedPer")}</span>
            </Grid>
            <Grid item style={{ width: "180px", margin: "0px 10px" }}>
              <FormSection
                id="visitorsProfileTypePerPeriod"
                title={"profileType"}
                formValue={[get(formValues, ["visitorsProfileTypePerPeriod"])]}
                setFormValue={(name, index, value) => handleChange(name, value)}
                type="select"
                options={{
                  options: [
                    {
                      id: 1,
                      name: "Resident",
                    },
                  ],
                }}
                noMarginBottom
                labelClass={classes.inputLabel}
              />
            </Grid>
            <Grid item style={{ marginBottom: "11px" }}>
              {I18n.get("scheduler_perDayOnAPeriodOf")}
            </Grid>
            <Grid item style={{ width: "80px", margin: "0px 10px" }}>
              <FormSection
                noLabel
                id="visitorsPeriod"
                formValue={[get(formValues, ["visitorsPeriod"])]}
                setFormValue={(name, index, value) => handleChange(name, value)}
                type="select"
                options={{
                  options: map(Array.from(Array(7).keys()), (i) => ({
                    id: i + 1,
                    name: toString(i + 1),
                  })),
                }}
                noMarginBottom
                labelClass={classes.inputLabel}
              />
            </Grid>
            <Grid item style={{ marginBottom: "11px" }}>
              {I18n.get("scheduler_daysStartingOn")}
            </Grid>
            <Grid item style={{ width: "180px", marginLeft: "10px" }}>
              <DatePicker
                name="visitorsStartDate"
                value={get(formValues, ["visitorsStartDate"]) || new Date()}
                onChange={(name, date) => handleChange(name, date)}
                dateOnly
                formatLabel={formatDateLabel}
                style={{ marginBottom: "0px !important" }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ paddingLeft: "30px" }}>
          <IncrementalInput
            name="visitorsPerProfileTypePerPeriod"
            value={get(formValues, ["visitorsPerProfileTypePerPeriod"])}
            handleChange={(value) =>
              handleChange("visitorsPerProfileTypePerPeriod", value)
            }
          />
        </Grid>
        <Grid item style={{ marginTop: "50px" }}>
          <Grid container alignItems="flex-end">
            <Grid item className="flexCenter">
              <Checkbox color="primary" checked={true} />
              <span>{I18n.get("scheduler_visitorsAllowedPer")}</span>
            </Grid>
            <Grid item style={{ width: "180px", marginLeft: "10px" }}>
              <FormSection
                id="visitorsProfileType"
                title={"profileType"}
                formValue={[get(formValues, ["visitorsProfileType"])]}
                setFormValue={(name, index, value) => handleChange(name, value)}
                type="select"
                options={{
                  options: [
                    {
                      id: 1,
                      name: "Resident",
                    },
                  ],
                }}
                noMarginBottom
                labelClass={classes.inputLabel}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ paddingLeft: "30px" }}>
          <IncrementalInput
            name="visitorsPerProfileType"
            value={get(formValues, ["visitorsPerProfileType"])}
            handleChange={(value) =>
              handleChange("visitorsPerProfileType", value)
            }
          />
        </Grid>
        <Grid item style={{ marginTop: "50px" }}>
          <Grid container alignItems="flex-end">
            <Grid item className="flexCenter">
              <Checkbox color="primary" checked={true} />
              <span>{I18n.get("scheduler_visitorsAllowedPer")}</span>
            </Grid>
            <Grid item style={{ width: "180px", margin: "0px 10px" }}>
              <FormSection
                id="visitorsZoneType"
                title2={I18n.get("companies_zoneType")}
                formValue={[get(formValues, ["visitorsZoneType"])]}
                setFormValue={(name, index, value) => handleChange(name, value)}
                type="select"
                options={{
                  options: [
                    {
                      id: 1,
                      name: "Resident",
                    },
                  ],
                }}
                noMarginBottom
                labelClass={classes.inputLabel}
              />
            </Grid>
            <Grid item style={{ marginBottom: "11px" }}>
              {I18n.get("scheduler_perTimeSlot")}
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ paddingLeft: "30px" }}>
          <IncrementalInput
            name="visitorsPerZoneType"
            value={get(formValues, ["visitorsPerZoneType"])}
            handleChange={(value) => handleChange("visitorsPerZoneType", value)}
          />
        </Grid>
      </Grid>
    );
  }

  return null;
};

export default withStyles(styles)(VisitRestrictionsSettings);
